$(document).ready(function () {
    changeEvents();
    if (isTouch) {
        touchDropDowns();
    }
});

$(window).on('scroll', function () {
})

$(window).on('resize', function () {
    changeEvents();
});

$(window).on('orientationchange', function () {
    changeEvents();
});

// events to be recreated when window changes
function changeEvents() {
    mobileMenu();
    //closeMenu();
}

// initialise mobile menu functions
function mobileMenu() {
    mainMenuButton();
    subMenuToggle();
}

// main menu button toggle
function mainMenuButton() {
    $(".main-menu-button").off('click').on('click', function () { toggleAction(); });
    var isToggling = false;
    function toggleAction() {
        if (!$(".main-menu-button").is(":visible")) { return };
        if (isToggling) { return }
        isToggling = true;
        $('.main-menu-button').toggleClass('active');
        $(".main-menu-items").toggleClass('active').promise().done(function () { isToggling = false });
    }
}

// toggle sub menus
function subMenuToggle() {
    var mainMenuSubAnchor = $('.main-menu-sub').prev('a');
    if (mainMenuSubAnchor.find('.sub-menu-toggle').length == 0) {
        mainMenuSubAnchor.append('<span class="sub-menu-toggle" />');
    }
    if ($('a').attr("onClick") != undefined) { }
    $('.sub-menu-toggle').on('click', function () {
        $(this).parents('li').toggleClass('active');
        return false;
    });
}

// make nav areas touch compatible
function touchDropDowns() {
    var dropdownClass = 'dropdown';
    var activeClass = 'visible';
    $('.' + dropdownClass + ' > a').click(function () {
        var thisParent = $(this).parent('.' + dropdownClass);
        if (!thisParent.hasClass(activeClass)) {
            thisParent.removeClass(activeClass);
            thisParent.addClass(activeClass);
        }
        else {
            thisParent.removeClass(activeClass);
        }
        return false;
    });
    $('.main-menu-sub').append('<span class="fa fa-times main-menu-sub-close"></span>');
    $('.main-menu-sub-close').on('click', function () {
        $(this).parents('.main-menu-sub').hide();
    });
    $('.main-menu .has-sub-menu').click(function () {
        $(this).next('.main-menu-sub').show();
        return false;
    });
}

function closeMenu() {
    if ($(".main-menu-button").is(":visible") && $(".main-menu-items").is(":visible")) {
        $('.main-menu-button').removeClass('active');
        $(".main-menu-items").removeClass('active').promise().done(function () { isToggling = false });
        $('.sub-menu-toggle').parents('li').removeClass('active');
    };
}

/*************************************
- Making the navigation menu accessible by allowing tabbing to keep window open
**************************************/

var tabMenuBar = {};

tabMenuBar.bind = function () {
    tabMenuBar.container = $(".main-menu");
    tabMenuBar.items = tabMenuBar.container.find(".main-menu-items > li");

    tabMenuBar.setListeners();
};

tabMenuBar.setListeners = function () {
    $('.main-menu').on('focusin', '.main-menu-items > li > a', function () {
        tabMenuBar.bindDocClick();
        tabMenuBar.bindArrowClick();
        tabMenuBar.activate($(this));
    });
};

tabMenuBar.activate = function (item) {
    item
        .parent("li")
        .addClass("active")
        .siblings("li")
        .removeClass("active");
};

tabMenuBar.hideActive = function () {
    for (var i = 0; i < tabMenuBar.items.length; i++) {
        $(tabMenuBar.items[i]).removeClass("active");
    }
};

tabMenuBar.hideFocus = function () {
    for (var i = 0; i < tabMenuBar.items.length; i++) {
        $(tabMenuBar.items[i]).removeClass("focus-active");
    }
};

tabMenuBar.handleArrowClick = function (e) {
    e.stopImmediatePropagation();

    var target = $(e.target);

    if (!target.parents().hasClass("active")) {
        tabMenuBar.unbindDocClick();
        return;
    }

    var item = target.parents(".active").find("> ul > li");

    switch (e.keyCode) {
        //case 37:
        //    //console.log('Left key pressed');
        //    e.preventDefault();
        //    tabMenuBar.tabUpList(item);
        //    break;
        case 38:
            //console.log('Up key pressed');
            e.preventDefault();
            tabMenuBar.tabUpList(item);
            break;
        //case 39:
        //    //console.log('Right key pressed');
        //    e.preventDefault();
        //    tabMenuBar.tabDownList(item);
        //    break;
        case 40:
            //console.log('Down key pressed');
            e.preventDefault();
            tabMenuBar.tabDownList(item);
            break;
    }

};

tabMenuBar.tabUpList = function (item) {

    if ($(".focus-active > ul > li").first().find("a").is(":focus")) {
        $(item).parents(".active").find(".main-menu-item").focus();
        tabMenuBar.hideFocus();
    } else {
        $(".focus-active > ul > li > a:focus").parent().prev().find("a").focus();
    }
};

tabMenuBar.tabDownList = function (item) {

    if (!$(item).parents(".active").hasClass("focus-active")) {
        $(item).parents(".active").addClass("focus-active");
        $(item).first().find("a").focus();
    } else {
        $(".focus-active > ul > li > a:focus").parent().next().find("a").focus();
    }
};

tabMenuBar.handleDocClick = function (e) {
    e.stopImmediatePropagation();
    var target = $(e.target);

    if (!target.parents().hasClass("active")) {
        tabMenuBar.unbindDocClick();
        tabMenuBar.hideActive();
        tabMenuBar.hideFocus();
        return;
    }
};

tabMenuBar.bindArrowClick = function () {
    document.addEventListener('keydown', tabMenuBar.handleArrowClick);
};

tabMenuBar.unbindArrowClick = function () {
    document.removeEventListener('keydown', tabMenuBar.handleArrowClick);
};

tabMenuBar.bindDocClick = function () {
    document.addEventListener('mouseup', tabMenuBar.handleDocClick);
};

tabMenuBar.unbindDocClick = function () {
    document.removeEventListener('mouseup', tabMenuBar.handleDocClick);
};

tabMenuBar.init = function () {
    if ($('.main-menu').length > 0) {
        tabMenuBar.bind();
    }
};

$(function () {
    tabMenuBar.init();
});
